// extracted by mini-css-extract-plugin
export default {"text":"DrawdownsSurplusModal_text__azORR","actions":"DrawdownsSurplusModal_actions__Wt+7p","button":"DrawdownsSurplusModal_button__14YNW"};